import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import styles from "./ProfileMenu.module.scss";
import { MisterIcon } from "@rtel/mister-icons";


const ProfileMenu = (props: any) => {

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState<boolean>(false);
  const [object, setObject] = useState<UserObject>();

  function getInitials(firstName: string, lastName: string) {
    let initials = firstName.slice(0, 1).toUpperCase();
    initials += lastName.slice(0, 1).toUpperCase();
    return initials;
  }

  useEffect(() =>{
    const getAuthUser = localStorage.getItem(`${process.env.REACT_APP_BASENAME}_authUser`);
    if(getAuthUser){
      const obj = JSON.parse(getAuthUser);
      setObject(obj.applicationUser);
    }
  }, [])
 
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          {object && (
              <>
              <div className={styles.userCircleSmall}>
                {getInitials(object.firstName, object.lastName)}
              </div>
              </>
            )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end dropdown-menu-custom profile-menu-dropdown">
          <DropdownItem header className="text-center" >
            {object && (
              <>
              <div className={styles.userCircle}>
                {getInitials(object.firstName, object.lastName)}
              </div>
              <div  className={styles.name}>{object.firstName} {object.lastName}</div>
              </>
            )}
          </DropdownItem>
          <DropdownItem divider />

          <Link to="/Settings" className="d-none">
            <DropdownItem className={styles.text}>
              {" "}
              
              {props.t("Profile")}{" "}
            </DropdownItem>
          </Link>

          <Link to="/Settings" className="d-none">
            <DropdownItem className={styles.text}>
              <span className="badge bg-success float-end">11</span>
              
              {props.t("Settings")}
            </DropdownItem>
          </Link>

          <Link to="/logout">
            <DropdownItem  className={styles.logout}>
              
                <MisterIcon name="CollapseOut" size="sm" />
                <span>{props.t("Logout")}</span>
              
            </DropdownItem>
          </Link>
          
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};
export default withTranslation()(ProfileMenu);

interface UserObject {
  active: boolean;
  appID: number;
  deleted: boolean;
  email: string;
  firstName: string;
  id: number;
  ipRestriction: string;
  languageId: number;
  lastName: string;
  loginType: number;
  resource: string;
  resourceName: string;
  userType: number;
  username: string;
  visible: boolean;
}
